const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

'use strict';
const Fancybox = {
	/**
	 * @description Initialize Fancybox functionality
	 */
	init: function() {
		// Initialize the Fancybox popup functionality
		this.fancyboxPopup('.js-popup-trigger', 'popup-custom-class');
	},

	/**
	 * @description Fancybox custom popup functionality
	 * @param {string} trigger - Selector for popup triggers
	 * @param {string} customClass - Optional custom class for Fancybox popups
	 */
	fancyboxPopup: (trigger, customClass = '') => {
		// Add a click event listener to each trigger element
		$(trigger).on('click', function(e) {
			e.preventDefault(); // Prevent default link behavior

			// Get the popup ID from the trigger's data attribute
			const popupId = $(this).data('popup-id');

			// Find the popup element matching the popup ID
			const popup = $(`[data-popup="${popupId}"]`);

			// Check if the popup exists
			if (popup.length === 0) {
				console.error(`Popup not found for ID: ${popupId}`);
				return;
			}

			// Open the Fancybox popup
			$.fancybox.open({
				src: popup, // Pass the popup element as the source
				type: 'inline', // Specify inline type for the popup
				smallBtn: true, // Display the small close button
				baseClass: customClass, // Apply a custom class, if any
			});
		});
	}
};

export default Fancybox;
